import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    artists: [],
    is_toggled: false
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setArtist(state, payload) {
      state.artists = payload
    },
    setToggle(state) {
      state.is_toggled = !state.is_toggled
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.label
        .get('myartists')
        .then(r => {
          commit('setArtist', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    toggle({ commit }) {
      commit('setToggle')
    },
    addRemoveFavorite({ dispatch }, id) {
      axios.label
        .post('myartists/favorite', {
          favorite: id
        })
        .then(() => {
          dispatch('read')
        })
    },
    removeArtist({ dispatch }, id) {
      axios.label
        .post('myartists/remove', {
          artist: id
        })
        .then(() => {
          dispatch('read')
        })
    },
    saveArtist({ dispatch }, artist) {
      axios.label
        .post('myartists', {
          id: artist.id,
          name: artist.name,
          spotify: artist.spotify,
          facebook: artist.facebook,
          instagram: artist.instagram,
          website: artist.website,
          youtube: artist.youtube
        })
        .then(() => {
          dispatch('read')
        })
    },
    updateArtist({ dispatch }, artist) {
      axios.label
        .post('myartists/update', {
          id: artist.id,
          name: artist.name,
          spotify: artist.spotify,
          facebook: artist.facebook,
          instagram: artist.instagram,
          website: artist.website,
          youtube: artist.youtube
        })
        .then(() => {
          dispatch('read')
        })
    },
    deleteImage({ dispatch }, form) {
      axios.label
        .post('myartists/image/delete', {
          id: form.id,
          file: form.file
        })
        .then(() => {})
    },
    async getArtistId({ commit }) {
      commit('setLoading', true)
      return await axios.label
        .get('myartists/id')
        .then(r => {
          commit('setLoading', false)
          return r.data.data
        })
        .catch(() => {
          commit('setLoading', false)
          return null
        })
    }
  },

  getters: {
    toggled: state => {
      return state.is_toggled
    }
  }
}
